var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"tipo-ata","rota-base":"/admin/tipo-ata","titulo-singular":"Tipo de Ata","campos-extras":[]}})
}
var staticRenderFns = []

export { render, staticRenderFns }